import { PERM } from '../constants/permissions';
import {
  AUTOMATION_ACTION_PERMISSIONS,
  REQUIRES_ALL_PERMISSIONS,
} from '../constants/automationActions';

const ACTION_MANAGE_PERMISSIONS = {
  ...AUTOMATION_ACTION_PERMISSIONS,
  create_task: [PERM.TASKS_MANAGE],
  update_task: [PERM.TASKS_MANAGE],
  send_email: [PERM.COMMUNICATIONS_MANAGE],
  add_note: [PERM.ACCOUNTS_MANAGE],
  log_activity: [PERM.ACCOUNTS_MANAGE],
  send_survey: [
    PERM.COMMUNICATIONS_MANAGE,
    PERM.CAMPAIGNS_MANAGE,
    PERM.WORKFLOWS_MANAGE,
  ],
  create_contact: [PERM.ACCOUNTS_MANAGE],
  create_meeting: [PERM.MEETINGS_MANAGE],
  generate_qbr: [PERM.ACCOUNTS_MANAGE],
  refresh_health_score: [PERM.ACCOUNTS_MANAGE],
};

/** Whether the user holds the permissions needed to execute an action type. */
export const canExecutePendingAction = (actionType, hasAnyPermission) => {
  const required = ACTION_MANAGE_PERMISSIONS[actionType] || [];
  if (required.length === 0) return false;
  if (REQUIRES_ALL_PERMISSIONS.has(actionType)) {
    return required.every((permission) => hasAnyPermission([permission]));
  }
  return hasAnyPermission(required);
};
